export default __webpack_public_path__ + "static/be19978b3e9d55bbaa4b99aae9fe81bd.png";